export default '/build/c6c6121e.png'